import { Autocomplete, Box, TextField } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useAuthentication } from 'src/features/authentication/context';
import { useGetAllTagsQuery } from 'src/hooks/reactQueryApiHooks';
import { useCustomDashboardContext } from 'src/contexts/customDashboardContext/customDashboard.context';
// import { fontSizesOptions } from 'src/components/SCADA/config/elementsOptions';
import { NewSite } from 'src/types/sites/sites';

export const LiveTagDrawerContent = () => {
  const {
    customerId: { value: customerId },
    sites,
  } = useAuthentication();

  const { selectedNode, updateNodeData, nodes } = useCustomDashboardContext();
  const [formValues, setFormValues] = useState({
    isDisplayName: true,
    siteId: '',
    tagId: '',
    gatewayId: '',
    textSize: '11px',
  });

  const [selectedSiteId, setSelectedSiteId] = useState<string>('');

  const siteOptions: NewSite[] = useMemo(() => sites?.value ?? [], [sites]);

  const { tags } = useGetAllTagsQuery({ customerId: customerId!, siteId: selectedSiteId });

  const selectedTagObj = useMemo(() => {
    if (!tags) return null;
    return tags.find((a: any) => a.id === formValues.tagId) ?? null;
  }, [tags, formValues.tagId]);

  const onChangeHandler = (name: string, value: string | boolean | null) => {
    setFormValues((prevState) => {
      const updated = { ...prevState, [name]: value };

      if (selectedNode?.id) {
        updateNodeData(selectedNode.id, updated);
      }

      return updated;
    });
  };

  useEffect(() => {
    if (!selectedNode?.id) return;

    const findNode = nodes.find((node) => node.id === selectedNode?.id);

    const siteId = (findNode?.data as { siteId?: string })?.siteId ?? '';
    const tagId = (findNode?.data as { tagId?: string })?.tagId ?? '';
    const gatewayId = (findNode?.data as { gatewayId: string })?.gatewayId ?? '';
    const isDisplayName = (findNode?.data as { isDisplayName?: boolean })?.isDisplayName ?? true;
    const textSize = (findNode?.data as { text?: string; textSize?: string })?.textSize ?? '11px';

    setFormValues({
      siteId,
      tagId,
      isDisplayName,
      textSize,
      gatewayId,
    });
    setSelectedSiteId(siteId);
  }, [selectedNode?.id, nodes]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Autocomplete
        value={siteOptions.find((s) => s.id === formValues.siteId) ?? null}
        size="small"
        onChange={(_, selectedSite) => {
          if (selectedSite) {
            setSelectedSiteId(selectedSite.id);
            onChangeHandler('siteId', selectedSite.id);

            onChangeHandler('tagId', null);
            onChangeHandler('gatewayId', null);
          } else {
            setSelectedSiteId('');
            onChangeHandler('siteId', null);
            onChangeHandler('tagId', null);
            onChangeHandler('gatewayId', null);
          }
        }}
        renderInput={(params) => (
          <TextField {...params} label="Select Site" data-sm="select-site-input" />
        )}
        options={siteOptions}
        getOptionLabel={(option) => option.siteName}
        renderOption={(props, option) => (
          <li {...props} key={`${option.id}-${option.siteName}`}>
            {option.siteName}
          </li>
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
      />

      <Autocomplete
        size="small"
        value={selectedTagObj}
        onChange={(_, selectedTag) => {
          if (selectedTag) {
            onChangeHandler('tagId', selectedTag.id);
            onChangeHandler('gatewayId', selectedTag.gatewayId);
          } else {
            onChangeHandler('tagId', null);
            onChangeHandler('gatewayId', null);
          }
        }}
        renderInput={(params) => (
          <TextField {...params} label="Select Tag" data-sm="select-tag-input" />
        )}
        options={tags ?? []}
        getOptionLabel={(option) => option?.displayName}
        renderOption={(props, option) => (
          <li {...props} key={`${option.id}-${option.displayName}`}>
            {option.displayName}
          </li>
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        disabled={!selectedSiteId}
      />

      {/* <Autocomplete
        size="small"
        onChange={(_, selectedTextSize) => {
          onChangeHandler('textSize', selectedTextSize as string);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Text Size"
            data-sm="text-size-input"
            value={formValues.textSize}
          />
        )}
        options={fontSizesOptions}
      /> */}
      {/* <FormControlLabel
        control={
          <Switch
            value={formValues.isDisplayName}
            name="isDisplayName"
            defaultChecked
            onChange={(e) => onChangeHandler(e.target.name, e.target.checked)}
          />
        }
        label="Display name"
      /> */}
    </Box>
  );
};
